module.exports = __webpack_public_path__ + "img/ic-ic-arrow-r-gray.0c4deded.svg";